<template>
  <div class="w-100">
    <a 
      class="block__absolute block__absolute--auto" 
      @click="step == 2? step=1: $emit('backClickedFromForgot')"><img 
        class="icon icon-xs" 
        src="@/assets/img/icons/svgs/solid/arrowLeft.svg"></a>

    <div class="card-header bg-transparent pb-4 border-0">
      <div class="logo-head mx-auto" style=" maring-top: 30px; margin-bottom:80px;">
          <logo/>
        </div>
       <div>                 
      <form 
        v-if="step == 1" 
        role="form">
        <base-input
          v-model="email"
          alternative
          class="mb-3"
          prepend-icon="ni ni-email-83"
          placeholder="Enter email address"
        />
        <div 
          v-if="$v.email.$error" 
          class="error field">Valid email is required</div>

          <div 
            v-if="serverError.email" 
            class="error field">{{ serverError.email }}</div>
                
                    
        <div class="text-center">
          <base-button 
            type="primary" 
            class="my-4 btn-block" 
            @click="onResetClick">Reset Now</base-button>
        </div>

         <p class="text-center text-muted mb-5" style="margin-top: -15px">
          <a
            style="cursor: pointer"
            class
            @click="$emit('iAmNewClicked')"
          >
            <small>Sign Up</small>
          </a>
        </p>

      </form>


      <form 
        v-if="step == 2" 
        role="form">
        <div class="mb-1">You've requested to reset your password. Please check your email for the Reset Code and complete the form below.</div><br>
        <base-input
          v-show="false"
          v-model="email"
          alternative
          class="mb-3"
          prepend-icon="ni ni-email-83"
          placeholder="Email"
        />
        <div 
          v-if="$v.email.$error" 
          class="error field">Valid email is required.</div>

           <div 
            v-if="serverError.email" 
            class="error field">{{ serverError.email }}</div>

        <base-input
          v-model="code"
          alternative
          class="mb-3"
          prepend-icon="ni ni-email-83"
          placeholder="Reset Code"
        />
        <div 
          v-if="$v.code.$error" 
          class="error field">Valid reset code is required.</div>

           <div 
            v-if="serverError.code" 
            class="error field">
            <span v-for="(item, index) in serverError.code" :key="index">
              {{item}}
            </span>
            </div>

        <base-input
          v-model="password"
          alternative
          class="mb-3"
          prepend-icon="ni ni-lock-circle-open"
          type="password"
          placeholder="New Password"
        />
        <div 
          v-if="$v.password.$error" 
          class="error field">Passwords should be a minimum of 8 Characters, with at least one uppercase, one lowercase and one number or special character.</div>
        <base-input
          v-model="confirm"
          alternative
          class="mb-3"
          prepend-icon="ni ni-lock-circle-open"
          type="password"
          placeholder="Confirm New Password"
        />
        <div 
          v-if="$v.confirm.$required == false" 
          class="error field">Confirm password is required.</div>
        <div 
          v-if="$v.confirm.sameAsPassword == false" 
          class="error field">Confirm should match with password.</div>
                    
        <div class="text-center">
          <base-button 
            type="primary" 
            class="my-4 btn-block" 
            @click="onResetCompleteClicked">Change Password</base-button>
        </div>
      </form>
      </div>
      

    </div>

  </div>
</template>
<script>
import Logo from './Logo.vue';
import {mapGetters, mapActions, mapMutations, mapState} from 'vuex'
import { required, minLength, between, email, sameAs, helpers } from 'vuelidate/lib/validators'
const password = helpers.regex('password', /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)
export default {
  components: { Logo },
    name: "Forgot",
    data() {
        return {
            email: "",
            password:"",
            confirm:"",
            code: "",
            step: 1,
            serverError: {}
        }
    },
    validations: {
        email: {
            required,
            email
        },
        code: {
            required
        },
        password: {
            required,
            password
        },
        confirm: {
            required,
            password,
            sameAsPassword: sameAs('password'),
        }
    },
    computed: {
        ...mapState('user',['forgetData']),
        usersDataAsString () {
            return JSON.stringify(this.forgetData)
        }
    },
   
    methods: {
        ...mapMutations(['setLoading']),
        ...mapActions('user', ['performPasswordReset','completePasswordReset']),
        onResetClick() {
        
            this.$v.$touch()
            if (this.$v.email.$invalid) {
                return
            }

            // this.performLoginPassword({username:this.email, password:this.password}).then(r => {
            //    this.$router.push('/projects')
            // }).catch(err => {
            //     this.$snack.success('Invalid Credentials.')
            // })
            this.setLoading(true)
            this.performPasswordReset(
                {
                    email: this.email
                }
            ).then(r => {
                this.setLoading(false)
                this.$v.$reset()
                this.step = 2
                this.serverError = {}
            }).catch(e => {
                if(e.response && e.response.status == 400) {
                    this.$snack.success(e.response.data.message)
                    let res = e.response.data.message
                   this.serverError = {}
                   this.serverError = {email: res.email}

                }
                
                this.setLoading(false)
            })
        },

        onResetCompleteClicked() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                return
            }

            // this.performLoginPassword({username:this.email, password:this.password}).then(r => {
            //    this.$router.push('/projects')
            // }).catch(err => {
            //     this.$snack.success('Invalid Credentials.')
            // })
            this.setLoading(true)
            this.completePasswordReset(
                {
                    email: this.email,
                    code: this.code,
                    password: this.password,
                    password_confirmation: this.confirm
                }
            ).then(r => {
                this.setLoading(false)
                this.serverError = {}
                this.$emit('resetPasswordSuccess')
                
            }).catch(e => {
              //console.log(e.response)
                if(e.response.status == 400) {
                    let res = e.response.data.message
                    this.$snack.success(res);
                   this.serverError = {}
                   this.serverError = {code: res.code}
                }
                
                this.setLoading(false)
            })
        }
    }
}
</script>

<style lang="scss">
.logo-head {
  text-align: center;
  img {
    max-width: 120px;
    width: 100%;
  }
}
@media only screen and (min-width: 993px) {
  .logo-head {
    img {
      max-width: 170px;
    }
  }
}
</style>